import { useMemo } from 'react';

import { useSectorChatsNavigationQuery } from '@interfaces/graphql-typings';
import { UseChatNavigationType } from '@buyside/components/presentation/ChatLayout/ChatNavigation/chatNavigation';

const useSectorNavigation = (): UseChatNavigationType => {
  const { data, loading } = useSectorChatsNavigationQuery();

  const navigationItems = useMemo(
    () =>
      data?.sectorChats?.map(({ id: chatId, sector, unreadMessagesCount }) => ({
        title: `${sector?.name}`,
        to: '/' + chatId,
        unreadMessagesCount
      })) || [],
    [data?.sectorChats]
  );

  return {
    loading,
    navigationItems,
    navigationTitle: 'Sector Chats'
  };
};

export default useSectorNavigation;
